import { Shipment } from '@centra';

export const getShippedProductsQuantity = (shipment: Shipment) =>
  Object.values(shipment.products)
    .flat()
    .reduce((sum, product) => sum + product.quantity, 0);
